import React, { useState } from "react";
import { useSelector } from "react-redux";
import { calculateTotals, cuFormat } from "../../../../components/coreUiTable/Format";
import Table from "../../../../components/coreUiTable/Table";

export const ContactLogsTable = () => {
  let [filteredData, setFilteredData] = useState([]);
  const {
    chartsData: {
      tableData: {
        content: {
          tableInfo: {
            data = [],
            totals = [],
            colHeaders = [],
            columns = [],
            links = [],
            rowCalculations = []
          }
        }
      }
    }
  } = useSelector((state) => state.activities);

  const showTotals = totals && totals.length && filteredData.length > 1;

  const onFilteredItemsChange = (data) => {
    setFilteredData(data);
  };

  const formattedSlots = cuFormat({
    countTitle: "#",
    headers: colHeaders,
    columns: columns,
    links: links
  });

  let footerSlot = () => {
    return showTotals ? (
      <tfoot>
        <tr className="">
          <td>#</td>
          <td>Total</td>
          {colHeaders.slice(1).map((header, index) => {
            const renderFunc = formattedSlots[header];

            const value = {
              [header]: calculateTotals(
                filteredData,
                rowCalculations[index + 1],
                colHeaders,
                header
              )
            };

            return renderFunc(value, {});
          })}
        </tr>
      </tfoot>
    ) : null;
  };

  return (
    <Table
      table={{ data, colHeaders }}
      onFilteredItemsChange={onFilteredItemsChange}
      scopedSlots={formattedSlots}
      footerSlot={footerSlot()}
      sorter
      title=" "
      showCount
      hideFirstCol
    />
  );
};
